import React, { useEffect, useState } from "react";
import { Route, Link } from "react-router-dom";
import Spinner from "./../loading/Spinner";
import { userContext } from "./../../UserContext";
import { appContext } from "../../AppContext";
import { useFetch } from "../../Utils/Hooks/useFetch";
import { useTranslation } from "react-i18next";
import { Menu, Input } from "antd";
import {
  UsergroupAddOutlined,
} from "@ant-design/icons";

import { LayoutContainer } from "../../library/src";

export default function PrivateRoute(props) {
  const { t } = useTranslation(["login", "utils", "user"]);

  const { hasSearchBar : hasSearchBarProps, ...routeProps } = props;

  const [userLoginloading, setUserLoginLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // eslint-disable-next-linse
  const [appState, appDispatch] = React.useContext(appContext);
  const [userState, userDispatch] = React.useContext(userContext);
  const [doFetch] = useFetch();
  const [searchValue, setSearchValue] = useState(
    appState.userManagement.searchValue
  );

  useEffect(() => {
    doFetch("/user/current").then((response) => {
      if (response.isSuccess) {
        userDispatch({ type: "LOGGEDIN" });
        appDispatch({ type: "SETUSER", payload: response.result });
        setIsLoading(false);
        return;
      }

      setUserLoginLoading(true);
      userState.userManager.signinRedirect({
        extraQueryParams: {
          applicationName: "User management",
        },
      });
    });
    // eslint-disable-next-line
  }, []);

  if (isLoading || userLoginloading) {
    return <Spinner type="filled" />;
  }

  function logout() {
    userState.userManager.signoutRedirect();
  }

  const menu = (
    <>
      <Menu
        defaultSelectedKeys={["1"]}
        mode="inline"
        theme="dark"
        className="page-sider-menu"
        subMenuCloseDelay={0.6}
      >
        {appState.user.isAdministrator && (
          <Menu.Item key="10" icon={<UsergroupAddOutlined />}>
            <span>{t("menuitems.userManagement")}</span>
            <Link to="/user-management"></Link>
          </Menu.Item>
        )}
      </Menu>
    </>
  );

  function SearchBar() {
    function onSearchChange(values) {
      appDispatch({ type: "SETUSERMANAGEMENTSEARCH", payload: values });
    }

    function onChangeSearchValue(values) {
      setSearchValue(values.target.value);
    }

    return (
      <Input.Search
        onSearch={onSearchChange}
        style={{
          width: "480px",
          marginLeft: "24px",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
        size="large"
        value={searchValue}
        onChange={onChangeSearchValue}
        placeholder={t("user:users.searchPlaceHolder")}
      />
    );
  }

  return (
    <LayoutContainer
      userName={appState.user.userName}
      profileLink={`/user-management/user?id=${appState.user.id}`}
      homeLink={"/user-management"}
      logout={logout}
      menu={menu}
      topBarChildren={hasSearchBarProps === true && SearchBar()}
    >
      <Route {...routeProps} />
    </LayoutContainer>
  );
}
